// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b770915d","268":"fd018b9a","484":"9730337a","842":"21dc2a50","851":"91585ec4"}[chunkId] + ".chunk.js";
};